<div class="container">
    <h1>EXTRACCION DE INYECTORES Y CALENTADORES</h1>

   
    <div style="text-align: center;"> <img src="assets/imagenes/extraccion1.gif" width="480" height="360"><img
            src="assets/imagenes/extraccion2.jpg" width="480" height="360">
    </div>
</div>